import { render, staticRenderFns } from "./TablaModulos.vue?vue&type=template&id=52996b17"
import script from "./TablaModulos.vue?vue&type=script&lang=js"
export * from "./TablaModulos.vue?vue&type=script&lang=js"
import style0 from "./TablaModulos.vue?vue&type=style&index=0&id=52996b17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports